/* src/app/module/users/add-user/add-vehicle-details/add-vehicle-details.component.scss */
.form-container {
  margin: 0 auto;
  background: #ffffff;
  border-radius: 10px;
}
.close-icon {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  cursor: pointer;
  font-size: 1.5rem;
}
h2 {
  margin-bottom: 20px;
  font-size: 24px;
}
h3 {
  margin-top: 20px;
  font-size: 18px;
  font-weight: bold;
}
.custom-upload-button {
  margin-top: 33px;
  margin-bottom: 23px;
  border: none;
  padding: 10px 16px;
  font-size: 16px;
  font-weight: bold;
  border-radius: 8px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.3s ease, transform 0.3s ease;
}
.custom-upload-button:disabled {
  background-color: #FFD9AA;
  border: 1px solid #FFD9AA;
  cursor: not-allowed;
}
.custom-upload-button:hover:not(:disabled) {
  background-color: #e67e00;
  border: 1px solid #e67e00;
  transform: translateY(-2px);
}
.custom-upload-button .arrow {
  margin-left: 8px;
  font-size: 16px;
  transition: margin-left 0.3s ease;
}
.custom-upload-button:hover:not(:disabled) .arrow {
  margin-left: 12px;
}
::ng-deep ::placeholder {
  color: var(--Gray-900, #101828);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
}
::ng-deep .p-dropdown .p-dropdown-label.p-placeholder {
  color: var(--Gray-900, #101828);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  margin: 0;
}
::ng-deep .p-dropdown span {
  margin: 0px;
}
::ng-deep .p-inputgroup-addon {
  margin-bottom: 4px;
  height: 44px;
  margin-top: 4px;
}
.form-container {
  position: relative;
}
.form-container .uploaded-image-container {
  position: absolute;
  top: 10px;
  right: 10px;
  overflow: hidden;
  border: 1px solid #ccc;
  border-radius: 8px;
  box-shadow: 0 14px 28px rgba(0, 0, 0, 0.1);
  transition: border 0.3s;
}
.form-container .uploaded-image-container:hover {
  border: 1px solid #E4E7EC;
  border-radius: 8px;
}
.form-container .uploaded-image-container:hover .hover-overlay {
  display: flex;
}
.form-container .uploaded-image-container .uploaded-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.expanded-image {
  width: 100%;
  object-fit: cover;
}
.uploaded-image-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
}
.image-box {
  width: 150px;
  overflow: hidden;
  border: 1px solid #ddd;
  border-radius: 8px;
}
::ng-deep .p-image-preview {
  max-width: 80vw;
  max-height: 80vh;
}
::ng-deep .p-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: inherit;
}
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}
.loading-indicator {
  border: 10px solid #f3f3f3;
  border-top: 10px solid orange;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
::ng-deep .p-dropdown {
  margin-bottom: 4px;
  margin-top: 4px;
  height: 44px;
}
::ng-deep .p-inputtext {
  margin-bottom: 4px;
  margin-top: 4px;
}
::ng-deep .label {
  margin-bottom: 8px !important;
}
::ng-deep .formly-validation-message {
  margin-top: 4px;
  color: #e24c4c;
}
form {
  width: 100%;
}
::ng-deep .accessbtn {
  margin-top: 28px;
}
:host ::ng-deep .p-datepicker {
  width: 300px !important;
  height: auto !important;
  font-size: 12px;
  overflow: hidden;
}
::ng-deep .p-datepicker-group {
  flex-direction: column !important;
  width: 100% !important;
}
::ng-deep .p-datepicker-calendar {
  table-layout: fixed;
  width: 100% !important;
  font-size: 12px;
}
::ng-deep .p-datepicker td,
::ng-deep .p-datepicker th {
  padding: 0.25rem !important;
  text-align: center;
}
::ng-deep .p-datepicker-header {
  padding: 0.5rem;
  font-size: 13px;
}
/*# sourceMappingURL=add-vehicle-details.component-YQPBYECU.css.map */
